import React, { useEffect, useMemo, useRef, useState } from "react";
import ApiData from "../../api/ApiData";
import { ContainerSubTitleGrey } from "../ContainerSubTitleGrey";
import { ListSoftCompany } from "./ListSoftCompany";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import FilterData from "../../api/FilterData";
import { ButtonFunctional } from "../UI/ButtonFunctional";
import { ListLicensingNewSelect } from "../licensing/ListLicensingNewSelect";
import { RenewalLicensing } from "../licensing/RenewalLicensing";
import Memory from "../../api/Memory";
import Msg from "../../api/Msg";
import RolesState from "../../api/RolesState";
import Loader from "../Loader";
import Media from "../../api/Media";
import User from "../../api/User";
import { BtnFilterVer1 } from "../UI/BtnFilterVer1";
import { SideDrawer } from "@dmc/ui";
import { SoftUnlinkLicenseModal } from "./SoftUnlinkLicenseModal";

export const AllSoftCompany = observer(({ idSearch, setIdSearch, v4Layout }) => {
  const refComponent = useRef(null);

  useEffect(() => {
    Memory.writeCoordSoftCardCompany(refComponent.current.offsetTop);
  }, []);

  const [unlincModal, setUnlincModal] = useState(false);
  const [attachModal, setAttachModat] = useState(false);
  // Функция выбора лицензии

  const selectOneLic = () => {
    FilterData.sortFuncvalidPeriodDaysAB(ApiData.company.licensing_free);
    FilterData.selectlicense();
  };
  // Действие с клиентами/лицензиями
  // Привязать лицензию
  const actionClientLicSet = (e) => {
    if (!RolesState.attach_licensing) {
      return Msg.writeMessages("Нет прав");
    }
    setLicense(e);
    ApiData.getClientSoft(e);
    if (!ApiData.company.licensing_free.length) {
      return Msg.writeMessages("Нет свободных лицензий");
    }
    selectOneLic();
    setAttachModat(true);
    // }
  };
  // Отвязать лицензию
  const actionClientLicRemove = (e) => {
    ApiData.getClientSoft(e);
    setUnlincModal(true);
  };
  const unlincLicFunc = () => {
    ApiData.unlincLic();
    setUnlincModal(false);
  };
  // Cброс индекса лийцензии
  const resetIndexLicenseFunc = () => {
    setUnlincModal(false);
  };
  // Функция выбора лицензии из списка
  const selectFreeLicFunc = (e) => {
    if (e.valid_period_days >= 0) {
      FilterData.selectFreeLic(e);
      ApiData.attachLic();
      setAttachModat(false);
    } else {
      FilterData.selectFreeLic(e);
      setVisibleRenewalBlock(true);
      setAttachModat(false);
    }
  };

  // Продлить лицензию
  const [visibleRenewalBlock, setVisibleRenewalBlock] = useState(false);
  const [license, setLicense] = useState();
  const [sortNameSoft, setSortNameSoft] = useState(false);
  const [sortSoftVer, setSortSoftVer] = useState(true);

  const actionClientLicRenewal = (e) => {
    FilterData.selectFreeLic(e);
    setVisibleRenewalBlock(true);
  };

  // Сортировка софта
  useMemo(() => {
    if (!!idSearch) {
      FilterData.searchIdClient(idSearch);
    }
  }, [idSearch]);
  const [sortLastSession, setSortLastSession] = useState(false);
  // Функция сортировки по версии софта
  const sortSoftVersionFunc = () => {
    if (sortSoftVer) {
      FilterData.sortFuncSoftVersionBA(ApiData.company.clients_soft);
      setSortSoftVer(false);
    } else {
      FilterData.sortFuncSoftVersionAB(ApiData.company.clients_soft);
      setSortSoftVer(true);
    }
  };
  const sortSoftNameSoftFunc = () => {
    if (sortNameSoft) {
      FilterData.sortFuncSoftNameBA(ApiData.company.clients_soft);
      setSortNameSoft(false);
    } else {
      FilterData.sortFuncSoftNameAB(ApiData.company.clients_soft);
      setSortNameSoft(true);
    }
  };
  const sortLastSessionFunc = () => {
    if (sortLastSession) {
      FilterData.sortFuncLastSessionBA(ApiData.company.clients_soft);
      setSortLastSession(false);
    } else {
      FilterData.sortFuncLastSessionAB(ApiData.company.clients_soft);
      setSortLastSession(true);
    }
  };
  // Конец сортировки


  const headerClass = v4Layout
    ? "lic_container_header cc-v4-soft-header"
    : "lic_container_header";

  const showV4ActionColumn =
    v4Layout &&
    (RolesState.unlink_licensing ||
      RolesState.attach_licensing ||
      RolesState.licen_prol_id ||
      RolesState.check_licensing ||
      User.user?.is_superuser);

  const v4GridClass = v4Layout
    ? ` cc-v4-soft-grid ${
        showV4ActionColumn
          ? "cc-v4-soft-grid--with-action"
          : "cc-v4-soft-grid--no-action"
      }`
    : "";

  const rowClass = (base) => {
    if (!v4Layout) return base;
    const gridSuffix = showV4ActionColumn
      ? "cc-v4-soft-grid--with-action"
      : "cc-v4-soft-grid--no-action";
    return `${base} cc-v4-soft-row cc-v4-soft-grid ${gridSuffix}`;
  };

  const renderSoftListHeader = () => {
    if (v4Layout && !Media.mobile) {
      return (
        <>
          <button
            type="button"
            className="cc-v4-soft-th soft_list_name"
            onClick={sortSoftNameSoftFunc}
          >
            <span className="cc-v4-soft-th-label">Название ПО</span>
            <span className="cc-v4-sort-icon" aria-hidden="true" />
          </button>
          <label className="soft_list_client_id search_id_client_container cc-v4-soft-th-id">
            <span className="cc-v4-soft-th-label">ИД клиента</span>
            <input
              className="search_id_client cc-v4-soft-id-input"
              placeholder="Поиск…"
              onChange={(e) => setIdSearch(e.target.value)}
              value={idSearch}
              type="text"
              aria-label="Поиск по ID клиента"
            />
          </label>
          <button
            type="button"
            className="cc-v4-soft-th soft_list_last_session"
            onClick={sortLastSessionFunc}
          >
            <span className="cc-v4-soft-th-label">Последняя сессия</span>
            <span className="cc-v4-sort-icon" aria-hidden="true" />
          </button>
          <button
            type="button"
            className="cc-v4-soft-th soft_list_software_version"
            onClick={sortSoftVersionFunc}
          >
            <span className="cc-v4-soft-th-label">Версия ПО</span>
            <span className="cc-v4-sort-icon" aria-hidden="true" />
          </button>
          {showV4ActionColumn ? (
            <span className="soft_list_valid_action cc-v4-soft-th cc-v4-soft-th-static">
              <span className="cc-v4-soft-th-label">Статус / Действия</span>
            </span>
          ) : null}
        </>
      );
    }

    return (
      <>
        <span
          className="soft_list_name tabs_lgt_grey_border cr_p text_table_v2"
          onClick={sortSoftNameSoftFunc}
        >
          {!Media.mobile ? (
            <>
              Название ПО <BtnFilterVer1 />
            </>
          ) : (
            "ПО"
          )}
        </span>
        <label className="soft_list_client_id tabs_lgt_grey_border cr_p search_id_client_container text_table_v2">
          {!Media.mobile ? (
            <>
              <span className="">ИД клиента</span>
              <input
                className="search_id_client"
                placeholder="Поиск по id clients"
                onChange={(e) => setIdSearch(e.target.value)}
                value={idSearch}
                type="text"
              />
            </>
          ) : (
            "ID"
          )}
        </label>
        {Media.mobile ? null : (
          <span
            className="soft_list_last_session tabs_lgt_grey_border cr_p text_table_v2"
            onClick={sortLastSessionFunc}
          >
            Последняя сессия
            {window.innerWidth > 1280 ? <BtnFilterVer1 /> : null}
          </span>
        )}
        <span
          className="soft_list_software_version tabs_lgt_grey_border cr_p text_table_v2"
          onClick={sortSoftVersionFunc}
        >
          {!Media.mobile ? (
            <>
              Версия ПО <BtnFilterVer1 />
            </>
          ) : (
            "Версия"
          )}
        </span>
        {(RolesState.unlink_licensing ||
          RolesState.attach_licensing ||
          RolesState.licen_prol_id) ? (
          <span className="soft_list_valid_action tabs_lgt_grey_border cr_p text_table_v2">
            {Media.mobile ? "Лиц" : "Действие"}
          </span>
        ) : null}
      </>
    );
  };

  return (
    <div
      ref={refComponent}
      className={v4Layout ? "cc-v4-soft-list-root" : ""}
    >
      <div className={`${headerClass}${v4GridClass}`}>
        {renderSoftListHeader()}
      </div>
      {ApiData.company.clients_soft !== null &&
      ApiData.company.clients_soft.length !== 0 ? (
        <>
          <ListSoftCompany
            v4Layout={v4Layout}
            rowClass={rowClass}
            idSearch={idSearch}
            setIdSearch={setIdSearch}
            actionClientLicRemove={actionClientLicRemove}
            actionClientLicSet={actionClientLicSet}
            actionClientLicRenewal={actionClientLicRenewal}
          />
          {unlincModal ? (
            <SoftUnlinkLicenseModal
              clientId={ApiData.this_client_soft_id?.client_id}
              onConfirm={unlincLicFunc}
              onClose={resetIndexLicenseFunc}
            />
          ) : null}
        </>
      ) : ApiData.company.clients_soft !== null &&
        ApiData.company.clients_soft.length === 0 ? (
        <ContainerSubTitleGrey text="Клиенты программного оборудования не найдены" />
      ) : (
        <Loader />
      )}
      {attachModal ? (
        <SideDrawer
          open={attachModal}
          onClose={() => setAttachModat(false)}
          title="Привязать лицензию"
          usePortal={false}
          footer={
            <ButtonFunctional onClick={() => setAttachModat(false)}>
              Отмена
            </ButtonFunctional>
          }
        >
          <div className="site-modal-body">
            <p>Доступно лицензий: {ApiData.company.licensing_info.count_free}</p>
            <p>
              Привязать лицензию к клиенту -{" "}
              <span style={{ color: "var(--mast-blue)" }}>
                {ApiData.this_client_soft_id.client_id}
              </span>
            </p>
            <ListLicensingNewSelect selectFreeLicFunc={selectFreeLicFunc} />
          </div>
        </SideDrawer>
      ) : (
        null
      )}
      {visibleRenewalBlock ? (
        <RenewalLicensing setVisibleRenewalBlock={setVisibleRenewalBlock} />
      ) : (
        null
      )}
    </div>
  );
});
